module.exports = __webpack_public_path__ + "static/youtube-fcb68f881295b6f706bbab91f99e36b7.jpg";